import "../../shared/scripts/sentry";
import "./lib/htmx";
import {initToastManager} from "../../shared/components/toast/toast.global";
import {addTooltipScript} from "../../shared/components/tooltip/tooltip.global";
import {addUtils} from "../../shared/scripts/global";

/************************************************************
 * TYPE DEFINITIONS
 ************************************************************/
declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface DocumentEventMap {
    "dialog:open": DialogOpenEvent;
  }
}

// custom events dispatched on document
export type DialogOpenEvent = CustomEvent<{dialogId: string; triggerId: string}>;

console.log(`${process.env.PACKAGE_VERSION}, ${process.env.BUILD_DATE}`);

// only scripts that need to be globally available should be here
// these scripts will be loaded once on first load only
// subsequent partial page updates will not re-run this script

// scripts for components and pages should be part of the component/page content
// so that the scripts will still be loaded if the component is rendered as a partial
// or if the page is rendered with hx-boost

addUtils(window);
addTooltipScript(window);
initToastManager();
